import "./App.css";
import "./parameters.css";
import './masks.css'
import './pages/Style/PageStyle.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import ScrollToTop from "./utils/ScrollToTop";
import Layout from "./components/layout/Layout";

import Home from "./pages/Home/Home";

const KickStarter = lazy(() => import("./pages/Solutions/KickStarter/KickStarter"));
const Implementation = lazy(() => import("./pages/Solutions/Implementation/Implementation"));
const Consultancy = lazy(() => import("./pages/Solutions/Consultancy/Consultancy"));

const DigitalFactory = lazy(() => import("./pages/Use Cases/DigitalFactory/DigitalFactory"));
const DigitalWarehousing = lazy(() => import("./pages/Use Cases/DigitalWarehousing/DigitalWarehousing"));
const PaperlessOperations = lazy(() => import("./pages/Use Cases/PaperlessOperations/PaperlessOperations"));
const RealTimeProductionProcess = lazy(() => import("./pages/Use Cases/RealTimeProductionProcess/RealTimeProductionProcess"));

const Industry40 = lazy(() => import("./pages/Expertise/Industry4-0/Industry4-0"));
const IIoT = lazy(() => import("./pages/Expertise/IIoT/IIoT"));
const CyberSecurity = lazy(() => import("./pages/Expertise/CyberSecurity/CyberSecurity"));

const Articles = lazy(() => import("./pages/Articles/Articles"));
const Jobs = lazy(() => import("./pages/Jobs/Jobs"));
const JobOpening = lazy(() => import("./pages/Jobs/JobOpening/JobOpening"));

const PrivacyPolicy = lazy(() => import("./pages/Privacy/PrivacyPolicy"));

const About = lazy(() => import("./pages/About/About/About"));
const Contact = lazy(() => import("./pages/About/Contact/Contact"));
const Support = lazy(() => import("./pages/Support/Support"));

const RealWorldIndustry4_0 = lazy(() => import("./pages/Articles/RealWorldIndustry4.0/RealWorldIndustry4.0"));
const ComprehensiveGuideIndustry4_0 = lazy(() => import("./pages/Articles/ComprehensiveGuideIndustry4.0/ComprehensiveGuideIndustry4.0"));
const OperationalTechnology = lazy(() => import("./pages/Articles/OperationalTechnology/OperationalTechnology"));
const OTCyberSecurity = lazy(() => import("./pages/Articles/OTCyberSecurity/OTCyberSecurity"));

const Error = lazy(() => import("./pages/Error/Error"));

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <Suspense fallback={<div style={{padding:"4rem 2rem"}}>Loading...</div>}>
          <Routes>
            <Route path="/" element={<Home />} />

            {/* Solutions */}
            <Route path="/solutions/kickstarter" element={<KickStarter />} />
            <Route path="/solutions/implementation" element={<Implementation />} />
            <Route path="/solutions/consultancy" element={<Consultancy />} />

            {/* Expertise */}
            <Route path="/expertise/industrial4-0" element={<Industry40 />} />
            <Route path="/expertise/iiot" element={<IIoT />} />
            <Route path="/expertise/cyber-security" element={<CyberSecurity />} />

            {/* Use Cases */}
            <Route path="/use-cases/digital-factory" element={<DigitalFactory />} />
            <Route path="/use-cases/digital-warehousing" element={<DigitalWarehousing />} />
            <Route path="/use-cases/paperless-operations" element={<PaperlessOperations />} />
            <Route path="/use-cases/realtime-machine-integration" element={<RealTimeProductionProcess />} />

            {/* Articles */}
            <Route path="/articles" element={<Articles />} />
            <Route path="/articles/real-world-industry-4-0" element={<RealWorldIndustry4_0 />} />
            <Route path="/articles/guide-to-real-world-industry-4-0" element={<ComprehensiveGuideIndustry4_0 />} />
            <Route path="/articles/what-is-operational-technology" element={<OperationalTechnology />} />
            <Route path="/articles/ot-cyber-security" element={<OTCyberSecurity />} />

            {/* Jobs */}
            <Route path="/jobs" element={<Jobs />} />

            {/* About */}
            <Route path="/about" element={<About />} />
            <Route path="/contact-us" element={<Contact/>} />
            <Route path="/support" element={<Support />} />

            {/* Opening Jobs */}
            <Route path="/jobs/openings/:jobId" element={<JobOpening />} />

            {/* Privacy Policy */}
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />

            {/* Catch-all Error */}
            <Route path="*" element={<Error />} />
          </Routes>
        </Suspense>
      </Layout>
    </Router>
  );
}